/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import _ from "underscore";

import classNames from "classnames";
import React from "react";

export default class extends React.Component {
  static displayName = "ModalBody";

  render() {
    return <div style={{ padding: "16px 20px" }}>{this.props.children}</div>;
  }
}
